// libs
import React, { memo, useEffect } from 'react';

// components
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import CartComponent from 'shared/components/CartComponent/CartComponent';

// constants
import { NAV_KEY } from 'shared/components/BottomSheetOTPVerification/Mobile/constants';

// styles
import { OverlaySheet, OverlaySheetDesktop, OverlaySheetWrapper } from './styles';

// helpers
import { getDeviceType, DEVICE_TYPE } from 'shared/helpers/app';
import { getEligibleVariantName } from 'shared/components/ExperimentV2/helpers';
import { hideOverflowY, resetOverflowY } from 'shared/helpers/dom';

// svgs
import PositionedSvg from 'shared/components/CartComponent/PositionedSvg';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

interface CartBottomSheetNudgeProps {
  hide?: () => void;
}

function CartBottomSheetNudge({ hide }: CartBottomSheetNudgeProps) {
  const isMobile = getDeviceType() === DEVICE_TYPE.MOBILE;
  // Get cart nudge configuration from remote config
  const cartNudgeConfig = useRemoteConfig("cartNudgeConfig");
  const { variant } = getEligibleVariantName('add-to-cart-nudge');


  const isNudgeEnabled = variant === 'atc-a' || variant === 'atc-b';

  useEffect(() => {
    if (!isNudgeEnabled) {
      return;
    }
    setTimeout(() => hideOverflowY('body', false), 500);
    return resetOverflowY;
  }, [isNudgeEnabled]);

  // If feature is disabled via remote config or user is not eligible, don't render
  if (!isNudgeEnabled) {
    return null;
  }

  const cartContent = () => (
    <OverlaySheetWrapper>
      <CartComponent isMobile={isMobile} onHide={hide} config={cartNudgeConfig} />
    </OverlaySheetWrapper>
  );

  if (isMobile) {
    return (
      <OverlaySheet
        navKey={NAV_KEY}
        transitionFrom={SHEET_TRANSITION.BOTTOM}
        hideOnOverlayClick={true}
        disableNav
        onHide={hide}
      >
        {cartContent()}
      </OverlaySheet>
    );
  }

  return (
    <OverlaySheetDesktop
      navKey={NAV_KEY}
      transitionFrom={SHEET_TRANSITION.RIGHT}
      disableNav
      hideOnOverlayClick={true}
      onHide={hide}
      showOverlay={true}
      overlayColor="transparent"
    >
      <PositionedSvg />
      {cartContent()}
    </OverlaySheetDesktop>
  );
}

export default memo(CartBottomSheetNudge);
